import React from 'react';

function LoginButtonAlt() {
  return (
    <div>
      <h3>Alternative OAuth Methods:</h3>
      
      {/* Method 1: Direct link */}
      <a href="/social/login/google-oauth2/" style={{
        display: 'inline-block',
        padding: '10px 20px',
        backgroundColor: '#4285f4',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px',
        margin: '5px'
      }}>
        Login with Google (Link)
      </a>
      
      {/* Method 2: Form submission */}
      <form action="/social/login/google-oauth2/" method="get" style={{display: 'inline-block', margin: '5px'}}>
        <button type="submit" style={{
          padding: '10px 20px',
          backgroundColor: '#34a853',
          color: 'white',
          border: 'none',
          borderRadius: '4px',
          cursor: 'pointer'
        }}>
          Login with Google (Form)
        </button>
      </form>
      
      {/* Method 3: Test debug endpoint */}
      <a href="/api/test-oauth-redirect/" style={{
        display: 'inline-block',
        padding: '10px 20px',
        backgroundColor: '#ea4335',
        color: 'white',
        textDecoration: 'none',
        borderRadius: '4px',
        margin: '5px'
      }}>
        Test OAuth Debug
      </a>
    </div>
  );
}

export default LoginButtonAlt;
